/**
 * ⟦C62 · lot 4 · friction 4⟧ **« Laisser tourner » dans la fenêtre Actions de la chambre.**
 *
 * C'est le seul bouton qui sert à « aller plus vite sans se prendre la tête » (Matt, 03/10) : l'outil de la
 * fin de partie. Il vivait tout en bas de l'écran de l'Équipe (1 750 px de haut), derrière un récapitulatif
 * invisible. Il est maintenant à côté de Publier et de Dormir dès que le producteur est en poste, et il dit
 * ce que l'équipe a fait au dernier tour (`retourEquipe.ts`).
 *
 * `Studio.tsx` n'en pose que l'élément : tout le reste (la condition d'apparition, le retour, le clic) vit
 * ici, dans le dossier de l'Équipe. Absent tant qu'il n'y a personne à qui laisser la main (⟦A-5⟧ « ce qui
 * n'est pas déverrouillé n'existe pas »), et posé dans le `<fieldset>` des Actions : une leçon bloquante le
 * grise avec les autres.
 */

import {
  collectModifiers,
  equipeActive,
  producteurActif,
  producteurPossede,
} from "@maxime/shared";

import { contenu } from "../../game/content";
import { useRunStore } from "../../stores/runStore";

import { laisserTourner, useRetourEquipe } from "./retourEquipe";
import { resumerDelegation, retourVisible } from "./resumeDelegation";

export function BoutonLaisserTourner() {
  const run = useRunStore((s) => s.run);
  const pending = useRunStore((s) => s.pending);
  const dernier = useRetourEquipe((s) => s.recap);
  const dernierRunId = useRetourEquipe((s) => s.runId);
  if (!run) return null;

  const c = contenu();
  const state = run.state;
  if (!equipeActive(c)) return null;
  const mods = collectModifiers(state, c);
  if (!producteurPossede(mods) || !producteurActif(state, mods)) return null;

  const recap = retourVisible({ recap: dernier, runId: dernierRunId }, run.runId, state);
  const legende = recap ? resumerDelegation(recap, c.equipe.libelles_courts?.arret).legende : "jusqu'à ton prochain choix";
  // Un événement en attente bloque toute action (le moteur le refuse) : on ne propose pas un bouton qui échouerait.
  const attendEvenement = state.pending_event !== null;

  return (
    <button
      className="bouton bouton-laisser-tourner"
      type="button"
      disabled={pending || attendEvenement}
      title="L'équipe joue à ta place, jusqu'au premier choix qui t'appartient : un événement, un palier, un nœud à acheter."
      onClick={() => void laisserTourner()}
    >
      ⏩ Laisser tourner
      <span className="cout">{legende}</span>
    </button>
  );
}
